import { useState } from "react";
import PageHeader from "@/components/PageHeader";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/contact", { ...form, kind: "inquiry" });
      setSent(true);
      toast.success("Thanks — we'll be in touch soon.");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="contact-page">
      <PageHeader eyebrow="Contact" title="Say hello"
        image="https://customer-assets-agu9un31.emergentagent.net/job_improv-prompt-engine/artifacts/m4q5ecwl_Liz%20Big%20Show%202024.webp"
        subtitle="Questions about live/online classes, workshops, performances, or bringing the Method to your organization? We'd love to hear from you." />
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {sent ? (
          <div className="bg-white rounded-2xl border border-[#dfd8da] p-10 text-center" data-testid="contact-success">
            <h2 className="font-display text-2xl text-[#550001]">Message received 🎭</h2>
            <p className="mt-2 text-[#545454]">We read every note and usually reply within a couple of days.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="bg-white rounded-2xl border border-[#dfd8da] p-8 space-y-4">
            <div>
              <Label htmlFor="c-name">Name</Label>
              <input id="c-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
                data-testid="contact-name" className="mt-1 w-full h-11 px-3 rounded-lg border border-[#d6cecf]" />
            </div>
            <div>
              <Label htmlFor="c-email">Email</Label>
              <input id="c-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
                data-testid="contact-email" className="mt-1 w-full h-11 px-3 rounded-lg border border-[#d6cecf]" />
            </div>
            <div>
              <Label htmlFor="c-message">Message</Label>
              <textarea id="c-message" required rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })}
                data-testid="contact-message" className="mt-1 w-full px-3 py-2 rounded-lg border border-[#d6cecf]" />
            </div>
            <Button type="submit" disabled={busy} className="w-full h-11 bg-[#920e12] hover:bg-[#550001] text-white font-bold" data-testid="contact-submit">
              {busy ? "Sending…" : "Send message"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
